"use es6";

const MotionGlobalConfig = {
  skipAnimations: false,
  useManualTiming: false
};
export { MotionGlobalConfig };